import { useMemo } from 'react';

import { useJobContext } from 'pages/Job/context';
import { formatToCurrency, getJobAmountToPay } from 'utils';

import { POINTS } from './constants';

import { PaymentPoint } from '../constants';

export interface OpenBankingPaymentCardHook {
  companyName: string;
  points: PaymentPoint[];
  toPay: string;
}

export default function useOpenBankingPaymentCard(): OpenBankingPaymentCardHook {
  const { isLoading, job, jobCompanyInfo } = useJobContext();

  const companyName = useMemo(() => {
    if (isLoading) return 'Your tradesperson';
    return jobCompanyInfo?.company_name ?? 'Your tradesperson';
  }, [isLoading, jobCompanyInfo]);

  const toPay = useMemo(() => formatToCurrency(getJobAmountToPay(job)), [job]);

  const points = useMemo(
    () =>
      POINTS.map((point) => ({
        ...point,
        text: point.text.replaceAll('{{companyName}}', companyName),
      })),
    [companyName],
  );

  return { companyName, points, toPay };
}
